import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LessorStakeholderDto, LessorInfoDto, LessorRepTypeDto, BankDto, AddressBookDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-stakeholder-table',
  templateUrl: './stakeholder-table.component.html',
  styleUrls: ['./stakeholder-table.component.scss']
})
export class StakeholderTableComponent implements OnChanges{

  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() banks: BankDto[];
  @Input() addressBook: AddressBookDto[];
  @Output() emitEdit = new EventEmitter<any>();
  lessorStakeholderArrayForm: FormGroup;
  selectedIndex = null;
  filteredDelete = [];
  listView = false;
  gridView = true;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(): void {
    this.lessorStakeholderArrayForm = this.fb.group({LessorStakeholder: this.fb.array([])});
    if(
      this.lessorStakeholders != null &&
      this.lessorStakeholders.length &&
      this.addressBook != null && this.addressBook.length) {
      this.filterStakeholder(this.selectedLessorInfo);
    }

  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  getAddressBook(id: string) {
    const foundAddressBook = this.addressBook.find(item => item.id === id);
    return foundAddressBook ? foundAddressBook : {};
  }



  filterStakeholder(selectedLessorInfo: LessorInfoDto) {
    const filteredLessorStakeholder = this.lessorStakeholders.filter(item => item.LessorsId === selectedLessorInfo.id);
    if(filteredLessorStakeholder != null && filteredLessorStakeholder.length) {
      const transformedLessorStakeholder = filteredLessorStakeholder.map(item => {
        return {
          addressBook: {
            BankName: this.getBankName(this.getAddressBook(item.AddressBookId)['BankId']),
            ...this.getAddressBook(item.AddressBookId)
          },
          ...item
        }
     });
      this.setLessorStakeholder(transformedLessorStakeholder);
    }
  }


  get lessorStakeholderFormArray() {
    return this.lessorStakeholderArrayForm.get('LessorStakeholder') as FormArray;
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }


  setLessorStakeholder(lessorStakeholders: any[]) {
    lessorStakeholders.forEach(lessor => {
      this.lessorStakeholderFormArray.push(this.fb.group({
        Name: lessor.addressBook.Name,
        PhoneNo: lessor.addressBook.PhoneNo,
        Address: lessor.addressBook.Address,
        AccountNo: lessor.addressBook.AccountNo,
        BankId: lessor.addressBook.BankId,
        AddressBookId: lessor.AddressBookId,
        LandTitleId: lessor.LandTitleId,
        LessorsId: lessor.LessorsId,
        id: lessor.id


      }));
    });
  }


  addLessorStakeholder(lessor: any) {
  this.lessorStakeholderFormArray.insert(0, this.fb.group({
      Name: lessor.Name,
      PhoneNo: lessor.PhoneNo,
      Address: lessor.Address,
      AccountNo: lessor.AccountNo,
      BankId: lessor.BankId,
      LessorsId: lessor.LessorsId,
      AddressBookId: lessor.AddressBookId,
      LandTitleId: this.selectedLessorInfo.LandTitleId,
      }));
  }


  onDelete(value, index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.lessorStakeholderFormArray.removeAt(index);
        if(value.id != null) {
          this.filteredDelete.push(value.id);
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  getBankName(id: string) {
    const found = this.banks.find(item => item.id === id);
    return found ? found.BankName : '';
  }



}
